import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
import { PermissionRequired, AccessControl} from "@careinfo/permission-required";

const VehicleCategoryList = () => {

  const defaultColumns: any = [

    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
        <AccessControl
        children={
          <TableActionButton editPath={`edit/${getValue()}`} />
        }
        allowedPermissions={<PermissionRequired/>}
        />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.VEHILCE_CATEGORY}
      queryKey={"vehicle-category"}
      columns={defaultColumns}
      addNewPagePath={"create"}
      tableName={"Vehicle Category"}
    />
  );
};

export default VehicleCategoryList;
